export default "__VITE_ASSET__DgtyIhaC__"